<template>
  <div class="documento-detail">
    <div>
      {{ requirement.name }}
    </div>
    <div
      class="documento-type"
      title="Tipo(s) de documento"
    >
      <span
        v-for="type in types"
        :key="type"
      >
        {{ type }}
      </span>
    </div>
    <div
      class="documento-status"
      title="Estatus"
    >
      {{ requirement.status }}
    </div>
    <slot name="botones" />
  </div>
</template>
<script>
export default {
  name: 'Documento',
  props: {
    requirement: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      types: JSON.parse(JSON.stringify(this.requirement.type)),
    };
  },
};
</script>
<style lang="scss">
  .requirement-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media(min-width: 576px) {
      flex-flow: row wrap;
      justify-content: space-around;
    }

    li {
      display: inline-block;
      margin: .25rem .5rem;
    }

    .documento-detail {
      align-items: center;
      display: flex;

      .btn-flat {
        padding: .25rem;
      }
      .btn-flat.danger-text {
        color: #ff4444;
        &:hover {
          color: #CC0000;
        }
      }
    }
    .documento-type {
      align-items: center;
      display: flex;

      span:first-child {
        margin-left: 0.25rem;
      }
      span {
        background-color: #eee;
        border-radius: 3px;
        color: #09C;
        cursor: default;
        font-size: .65rem;
        font-weight: 600;
        margin-right: 0.25rem;
        padding: .2rem;
      }
    }
    .documento-status {
      color: #212121;
      cursor: default;
      font-size: .65rem;
      font-weight: 600;
    }
  }
</style>
